import { useState, useEffect } from "react";
import "./DCComponentRouter.css";
import { PromptPair } from "../../wazawan/Wazawan";
import { Button } from "../../../ds2/components";
import { DCPreviewEmployeeRecord } from "./DCPreviewEmployeeRecord";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { DCEmployeeRecord } from "./DCEmployeeRecord";
import { DCAsset } from "./DCAsset";
import { DCReporting } from "./DCReporting";
import { DCPTORequest } from "./DCPTORequest";
import { DCPTOBalance } from "./DCPTOBalance";
import { DCPTOHistory } from "./DCPTOHistory";
import { DCFormFillEditor } from "./DCFormFillEditor";
import { AgentResponseMessage } from "winslow-core";
import { useNavigate } from "react-router-dom";
import { DC_COMPONENT_LABELS } from "winslow-core";
import { DCEmployeeRecordProfileCard } from "./DCEmployeeRecordProfileCard";
import { DCPTOPolicies } from "./DCPTOPolicies";
import { DCPTOPolicyEditor } from "./DCPTOPolicyEditor";
import { AppPTOPolicyEditor } from "../app-time-off/AppPTOPolicyEditor";
import { DCSlug } from "./DCSlug";
import { X } from "lucide-react";

export const NR_DELETE_THIS_EMPLOYEE_RECORD_ID =
  "dbb8a0bf-509c-491c-9d20-ce5961515405";

export type DCUIContext = {
  employeeRecordIds: string[] | undefined;
};

type DCComponentRouterProps = {
  message: AgentResponseMessage | null;
  lastUIMessageId: number;
  objectName: string;
  data: any;
  jumpRoute?: string;
};

const BREAKPOINT_SMALL = 900;
const MIN_COMPONENT_WIDTH = 600; // Minimum width for components to display properly

export const DCComponentRouter = ({
  message,
  lastUIMessageId,
  objectName,
  data,
  jumpRoute,
}: DCComponentRouterProps) => {
  const storeUser = useSelector(selectUser);
  const navigate = useNavigate();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  const [finalObjectName, setFinalObjectName] = useState<DC_COMPONENT_LABELS>(objectName as DC_COMPONENT_LABELS);
  const [finalLabel, setFinalLabel] = useState<string>(data?.label || "");
  const [finalData, setFinalData] = useState<any>(data);

  console.log("[DCComponentRouter] message: ", message);
  console.log("[DCComponentRouter] lastUIMessageId: ", lastUIMessageId);
  console.log("[DCComponentRouter] objectName: ", objectName);
  console.log("[DCComponentRouter] finalObjectName: ", finalObjectName);
  console.log("[DCComponentRouter] data: ", data);
  console.log("[DCComponentRouter] data typeof: ", typeof data.cloudURL);
  console.log("[DCComponentRouter] Current window size:", windowSize);

  const isOutdated = message ? message.id < lastUIMessageId : true;
  console.log("[DCComponentRouter] isOutdated: ", isOutdated);
  console.log("[DCComponentRouter] isOutdated lastUIMessageId: ", lastUIMessageId);
  console.log("[DCComponentRouter] isOutdated message.id: ", message?.id);


  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
      console.log("[DCComponentRouter] Window resized to:", {
        width: window.innerWidth,
        height: window.innerHeight
      });
      
      // Check if browser width is less than 600px
      if (window.innerWidth < BREAKPOINT_SMALL) {
        console.log("[DCComponentRouter] Browser width is less than 600px!");
      }
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleJumpToApp = () => {
    if (jumpRoute) {
      navigate(jumpRoute);
    }
  };

  const handleNavigation = (newObjectName: DC_COMPONENT_LABELS, newLabel: string, data: any) => {
    console.log("[DCComponentRouter] handleNavigation newObjectName: ", newObjectName);
    console.log("[DCComponentRouter] handleNavigation newLabel: ", newLabel);
    console.log("[DCComponentRouter] handleNavigation data: ", data);
    // alert("[DCComponentRouter] handleNavigation called: " + newObjectName + " " + newLabel);
    setFinalObjectName(newObjectName);
    setFinalLabel(newLabel);
    setFinalData(data);
  }

  // console.log("[DCComponentRouter] windowSize: ", windowSize);

  return (
    <>
      {message && (
        <>
          {/* Placeholder for small screens */}
          {/* {windowSize.width < BREAKPOINT_SMALL && (
            <div className="dc-component-placeholder">
              <span>Expand screen to view component</span>
              {jumpRoute && (
                <button 
                  className="jump-to-app-button"
                  onClick={handleJumpToApp}
                >
                  Jump to App
                </button>
              )}
            </div>
          )} */}

          {/* Main component content */}
          {windowSize.width >= 600 && (
            <div 
              className="dc-component-router"
              style={{
                width: windowSize.width >= BREAKPOINT_SMALL ? "100%" : "100%",
                maxWidth: windowSize.width >= BREAKPOINT_SMALL ? "none" : "100%"
              }}
            >
              {(() => {
                switch (finalObjectName as DC_COMPONENT_LABELS) {
                  case "employee-profile":
                    return (
                      <DCEmployeeRecordProfileCard
                        key={"employee-profile-" + message.id}
                        data={finalData}
                        message={message}
                        isOutdated={isOutdated}
                      />
                    );
                  case "pto-policy":
                    switch (finalLabel) {
                      case "new":
                      case "edit":
                        return (
                          <DCPTOPolicyEditor
                            key={"pto-policy-editor-" + message.id}
                            message={message}
                            data={finalData}
                            isOutdated={isOutdated}
                            onNavigation={handleNavigation}
                           />
                        );
                      default:
                        return (
                          <DCPTOPolicies
                            key={"pto-policy-" + message.id}
                            message={message}
                            isOutdated={isOutdated}
                            data={finalData}
                            onNavigation={handleNavigation}
                          />
                        );
                    }
                  case "pto-request":
                    switch (finalLabel) {
                      case "cancel":
                        return (
                          <DCSlug key={"pto-request-cancel-" + message.id}>
                            <X size="16" color="red" /> Canceled PTO Request
                          </DCSlug>
                        );
                      default:
                        return (
                          <DCPTORequest
                            key={"pto-request-" + message.id}
                            message={message}
                            isOutdated={isOutdated}
                            data={finalData}
                            onNavigation={handleNavigation}
                          />
                        );
                    }
                   
                  case "pto-balance":
                    return (
                      <DCPTORequest
                        key={"pto-balance-" + message.id}
                        message={message}
                        isOutdated={isOutdated}
                        data={finalData}
                        balanceOnly={true}
                      />
                    );
                  case "pto-history":
                    return (
                      <DCPTOHistory
                        key={"pto-history-" + message.id}
                        message={message}
                        isOutdated={isOutdated}
                        data={finalData}
                      />
                    );
                  case "asset":
                  case "form-fill":
                    return (
                      <DCAsset
                        key={"asset-" + message.id}
                        data={finalData}
                        isOutdated={isOutdated}
                        message={message}
                        preview={true}
                        onCancel={() => console.log("Asset cancelled")}
                        onSubmit={() => console.log("Asset submitted")}
                      />
                    );
                  case "form-fill-editor":
                    return (
                      <DCFormFillEditor
                        key={"form-fill-editor-" + message.id}
                        isOutdated={isOutdated}
                        title={finalData.title || finalData.fileName || finalData.name}
                        message={message}
                        cloudURL={finalData.cloudURL}
                        formFields={finalData.formFields}
                      />
                    );
                  case "employee-record":
                    return (
                      <></>
                      // <DCEmployeeRecord
                      //     id={NR_DELETE_THIS_EMPLOYEE_RECORD_ID}
                      //     // properties={[response.label]}
                      //     properties={[]}
                      //     onCancel={onCancel}
                      //     onSubmit={onSubmit}
                      // />
                    );
                  default:
                    return (
                      <span className="dc-component-router-default">
                        Unknown object: {finalObjectName}
                        <p />
                        Data: {JSON.stringify(finalData)}
                      </span>
                    );
                }
              })()}
            </div>
          )}
        </>
      )}
    </>
  );
};
